"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var category_convert_util_1 = require("../../util/category-convert.util");
var DataPoint = /** @class */ (function () {
    function DataPoint(id, name, skippedInAggregationRules, dataFormat, questionId, expression, aggregateArea) {
        this.id = id;
        this.name = name;
        this.skippedInAggregationRules = skippedInAggregationRules;
        this.dataFormat = dataFormat;
        this.questionId = questionId;
        this.expression = expression;
        this.aggregateArea = aggregateArea;
    }
    DataPoint.prototype.clone = function () {
        return new DataPoint(this.id, this.name && new idm_crosscutting_concepts_frontend_1.MultilingualString(this.name.toMap()), this.skippedInAggregationRules, this.dataFormat && this.dataFormat.clone(), this.questionId, this.expression && this.expression.clone(), this.aggregateArea);
    };
    DataPoint.prototype.toValidJson = function () {
        var json = this.clone();
        json.dataFormat.isMultiline = json.dataFormat.type === 2 ? !!json.dataFormat.isMultiline : null;
        json.dataFormat.isMultilingual = json.dataFormat.type === 2 ? !!json.dataFormat.isMultilingual : null;
        json.dataFormat.isComment = json.dataFormat.type === 6 ? true : null;
        json.dataFormat.isPercentage = json.dataFormat.type === 1 ? !!json.dataFormat.isPercentage : null;
        json.dataFormat.numberOfDecimalPlaces = json.dataFormat.type === 1 ? json.dataFormat.numberOfDecimalPlaces || 0 : null;
        json.questionId = json.dataFormat.type === 3 ? json.questionId : null;
        json.expression = json.dataFormat.type === 7 ? json.expression : null;
        json.name = category_convert_util_1.ConvertUtil.convertMultilingualStringToMap(json.name);
        return json;
    };
    Object.defineProperty(DataPoint.prototype, "isNone", {
        /**
         * Property left for backwards compatibility
         */
        get: function () {
            return this.skippedInAggregationRules;
        },
        set: function (value) {
            this.skippedInAggregationRules = value;
        },
        enumerable: true,
        configurable: true
    });
    return DataPoint;
}());
exports.DataPoint = DataPoint;
//# sourceMappingURL=data-point.model.js.map